import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { Spacer, SharedModal } from './'
import { ModalActions, ModalConfirmButton } from './ModalActions'

const BodyText = styled.div`
  color: ${p => p.theme.mediumGray};
  font-size: 18px;
  line-height: 33px;
`

class ModalConfirmation extends Component {
  static propTypes = {
    bodyText: PropTypes.string,
    isModalOpen: PropTypes.bool,
    title: PropTypes.string,
    toggleModal: PropTypes.func,
  }

  render() {
    const { bodyText, isModalOpen, toggleModal, title = 'Delete This Information' } = this.props

    return (
      <SharedModal isModalOpen={isModalOpen} title={title} toggleModal={toggleModal}>
        <Spacer space='15px' />
        <BodyText>{bodyText}</BodyText>
        <ModalActions>
          <ModalConfirmButton type='button' onClick={toggleModal}>
            Got it!
          </ModalConfirmButton>
        </ModalActions>
      </SharedModal>
    )
  }
}

export default ModalConfirmation
